/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['午夜', '清晨', '上午', '中午', '下午', '晚上', '凌晨'],
    ,
  ],
  [
    ['午夜', '早上', '上午', '中午', '下午', '晚上', '凌晨'],
    ['午夜', '清晨', '上午', '中午', '下午', '晚上', '凌晨'],
    ['午夜', '早上', '上午', '中午', '下午', '晚上', '凌晨']
  ],
  [
    '00:00', ['05:00', '08:00'], ['08:00', '12:00'], ['12:00', '13:00'], ['13:00', '19:00'],
    ['19:00', '24:00'], ['00:00', '05:00']
  ]
];
